<template>
  <div id="removeclass">
    <app-modal
      :modal-id="modalId"
      modal-alignment="top"
      modal-size="fullscreen"
      @close-modal="closeModal"
    >
    <template slot="header">
        <h5 class="modal-title">{{modalTitle}}</h5>
    </template>
    <template slot="body">
      <div class="row">
        <div class="col-sm-12 col-md-12 breadcrumb-side-button">
          <div class="float-md-right mb-3">
            <el-tooltip
              placement="top"
              :effect="theemMode.darkMode == true ? 'light' : 'dark'"
              :content="$t('instruction')">
                <button
                type="button"
                class="btn btn-primary btn-sm"
                data-toggle="modal"
                @click="instructionOpen">
                <!-- {{ $t("instruction") }} -->
                <app-icon name="book-open" />
              </button>

            </el-tooltip>
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true">
          <div class="alert alert-info" role="alert">
            <button type="button" class="close" @click.prevent="instructionClose">
              <h5 aria-hidden="true">&times;</h5>
            </button>
            <!-- <hr> -->
            <h5 class="alert-heading"><app-icon name="book-open" /> {{ $t("instructions_about_attach_document") }}</h5>
            <p class="mb-0">{{ $t("introduction_attach_document_detail") }}</p>
            <strong>Actions:</strong>
            <ul>
              <li><strong>{{ $t("view_document") }} :</strong> {{ $t("view_document_detail") }}</li>
              <li><strong>{{ $t("view_endorsement") }} :</strong> {{ $t("view_endorsement_detail") }}</li>
            </ul>
          </div>
        </div>
      </div>
      <app-overlay-loader v-if="preloader" />
        <div v-if="this.active != 1" class="mb-2">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-if="this.active < 3"> <a href="" @click.prevent="previous">Back</a></el-breadcrumb-item>
            <el-breadcrumb-item>Document</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <el-form v-if="active === 1">
          <form
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
            ref="form"
            :data-url="addurl">
            <div class="form-group row align-items-center">
              <div class="col-sm-6 mb-0">
                <label for="inputs_select_document">
                {{ $t("select_documents") }}
                </label>
                <app-input
                  id="inputs_select_document"
                  type="multi-select"
                  :placeholder="$t('select_documents')"
                  :list="document"
                  v-model="inputs.form_revision_id"
                />
                <p v-if="refreshShow == false" class="font-italic text-muted">
                    {{ $t("shortcut_submited_form_create") }} <span><a href="#" @click.prevent="createForm()">{{$t("click_here")+' '+$t("to_create_new_or_save_response")}}</a></span>
                </p>
                <p v-if="refreshShow == true" class="font-italic text-muted">
                  <a href="#" @click.prevent="refreshForm()">{{$t("refresh")}}</a><span> {{ $t("form_create_refresh") }}</span>
                </p>

              </div>
            </div>
          </form>
          <div class="row">
            <div class="col-12">
              <button
                type="button"
                class="btn btn-primary mr-2 mt-2"
                data-dismiss="modal"
                @click.prevent="submit"
                >
                  {{ $t("submit") }}
              </button>
            </div>

            <div class="col-12 mt-5">
              <div class="row" v-if="attach_documents.length > 0">
                <div class="col-sm-4 col-md-3 col-lg-3 mb-2" v-for="(document, index) in attach_documents" :key="index">
                  <div class="card-body" style="padding: 1rem;">
                    <div class="card card-with-shadow border-0 ">
                      <div class="card-body text-center">
                        <span>
                          <app-icon name="file"/>
                        </span>
                        <h6 class="mt-2 text-center mb-0">
                          {{ document.get_forms.name }}
                        </h6>
                        <small>Uploaded By: {{ document.user.role[0].name }}</small>
                      
                        <div class="text-muted d-flex align-items-start">
                          <div class="media-body d-flex justify-content-center mt-3">
                            <div class="d-flex" v-for="(endorsement,key) in document.site_doc_endorse_users" :key="key">
                              <el-tooltip
                                placement="top"
                                :effect="theemMode.darkMode == true ? 'light' : 'dark'"
                                :content="endorsement.user.full_name">
                                <i
                                  v-if="endorsement.status == 1"
                                  class="fa fa-user-check fa-lg mr-1"
                                  style="cursor: pointer;color: green;"
                                ></i>
                                <i
                                  v-else
                                  class="fa fa-user-times fa-lg mr-1"
                                  style="cursor: pointer;color: var(--side-bar-dark-text-color);"></i>
                              </el-tooltip>
                            </div>
                          </div>
                        </div>
                        <div class="text-center mt-3">
                          <a href="#" @click.prevent="viewDocument(document)"> View Document </a><br>
                          <a href="" @click.prevent="viewEndorse(document.pivot)">View Endorsement </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                <app-empty-data-block v-if="attach_documents.length == 0" :message="$t('nothing_to_show_message')"/>
            </div>
          </div>
        </el-form>
        <el-form v-if="active === 2">
          <form-preview :id="formBody" :response="response" :form_revision_id="formRevisionId" :form_id="formID" :userId="user_id"></form-preview>
        </el-form>
      </template>
      <template slot="footer">
        <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click="closeModal">
          {{ $t("close") }}
        </button>
      </template>
    </app-modal>

    <!--Site Document endorsement Modal-->
    <mysite-site-document-endore-modal
      v-if="isSiteDocEndorseModalActive"
      modal-id="endorse-Modal"
      :endorseData="endorseData"
      :type="type"
      @close-modal="isSiteDocEndorseModalActive = false"
    />
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../../../../app/Mixins/ModalMixin";
import { axiosPost, axiosGet } from "../../../../../../../Helpers/AxiosHelper";
import {
  GET_ATTACH_DOCUMENT,
  SITE_DOCUMENT_STORE,
  GET_SITE_ATTACH_DOCUMENT, 
  TASK_ATTACH_DOCUMENT_DELETE,
  SITE_DOCUMENT_ENDORSE
} from "../../../../../../../Config/ApiUrl";

export default {
  name: "AssignUser",
  mixins: [FormMixin, ModalMixin],
  props: {
    id: Number,
  },
  data() {
    return {
      refreshShow: false,
      instructionShow: false,
      isSiteDocEndorseModalActive: false,
      active: 1,
      formBody: 0,
      formID: 0,
      formRevisionId: 0,
      user_id: 0,
      taskId: 0,
      response: '',
      addurl: SITE_DOCUMENT_STORE,
      document: [],
      attach_documents: [],
      preloader: false,
      inputs: {},
      modalId: "demo-attach-document-Modal",
      modalTitle: this.$t("attach_generated_documnent"),
      assignUserList: [],
      type: '',
      endorseData: {},
    };
  },
  
  methods: {
    instructionOpen() {
      this.instructionShow = true;
    },
    instructionClose() {
      this.instructionShow = false;
    },
    submit() {
      if (typeof(this.inputs.form_revision_id) == 'undefined') {
          this.$toastr.w('Please Select Document First');
      }
      else {
                this.inputs.site_id = this.id;
        
                let formData = new FormData();
                Object.keys(this.inputs).forEach((key) => {
                formData.append(key,this.inputs[key]);
              });  
            this.save(formData);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.getAttachedDocument();
    },
     getDocument() {
      axiosGet(GET_ATTACH_DOCUMENT)
        .then((res) => {
          this.document = res.data;
        })
        .catch((error) => {
          
        });
    },
    getAttachedDocument() {
      axiosGet(GET_SITE_ATTACH_DOCUMENT + '/' + this.id)
        .then((res) => {
          
          this.attach_documents = res.data;
        })
        .catch((error) => {
          
        });
    },
    viewDocument(documentData) {
      this.formBody = documentData.form_body_id;
      this.formID = documentData.form_id;
      this.formRevisionId = documentData.id;
      this.user_id = documentData.created_by;
      this.response = 'save_response';
      // this.taskId = 0;
      this.active = 2;
    },
    previous() {
      this.active = 1;
    },
    viewEndorse(endorseData) {
      this.endorseData = endorseData;
      this.type = 'view_endorsement';
      this.isSiteDocEndorseModalActive = true;  
    },
    createForm() {
      this.refreshShow = true;
      window.open('/admin/documentlibrary/mydocument', '_blank');
    },
    refreshForm() {
      this.refreshShow = false;
      this.getDocument();

    },
  },
  mounted() {
    // $(function () {
    //   $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    // });
    this.getDocument();
    this.getAttachedDocument();
  },
  computed: {
    theemMode() {
      return this.$store.state.theme;
    },
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
